module.exports = __webpack_public_path__ + "media/images/flags/4x3/hun-b4afa8ba4b9a5494e6d28ffedb66d5e5.svg";